import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import pdf from "../images/collection-pdf.png";
import { useRef, useLayoutEffect } from "react";
import { getMeria } from "../service/service";
function MeriaSkhdomisOqmebi() {
  const ref = useRef(null);
  const [width, setWidth] = useState(10);
  const [content, setContent] = useState([]);

  useLayoutEffect(() => {
    setWidth(ref.current.offsetWidth);
  });

  useEffect(() => {
    const meriaBrdzanebebi = async () => {
      const response = await getMeria("meeting-protocols");
      setContent(response);
    };
    meriaBrdzanebebi();
  }, []);

  const ActsView = () => {
    return content?.map((item, index) => (
      <div className="" key={index}>
        <a href={`${item.file || item.url}`} target="blank">
          <span>{item.title}</span>

          <img src={pdf} alt="" />
        </a>
      </div>
    ));
  };
  return (
    <motion.div
      intial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="margin-280px">
        <header>
          <span
            className="big "
            id="meria"
            ref={ref}
            style={{ marginRight: width / 2 }}
          >
            {" "}
            {"მერია"}
          </span>
          <span>{"სხდომის ოქმები"} </span>
        </header>
        <div>
          <div className="sakrebulo-landing">
            <div className="landing-container">
              <div className="sajaroInfo">
                <ActsView />
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default MeriaSkhdomisOqmebi;
